var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editor-root" }, [
    _vm.isPlaceholderVisible
      ? _c("div", { staticClass: "editor-root__placeholder" }, [
          _vm._v("クリックしてテキストを入力")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "text-content__text",
      attrs: { id: _vm.id, contenteditable: "true" }
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "text-content__toolbar",
      class: { "text-content__toolbar--visible": _vm.focus },
      attrs: { id: _vm.toolbarId }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }